import cx from 'classnames'

import Styles from './UsageTable.module.scss'

interface Props {
  title: string
  data: UsageTableRow[]
}

export interface UsageTableRow {
  icon?: JSX.Element
  label: string
  value: string | number
  limit?: string | number
}

export const UsageTable = ({ title, data }: Props) => {
  return (
    <div className={Styles.container}>
      <p className={Styles.header}>{title}</p>
      {data.map((row) => (
        <div className={Styles.usageRow} key={row.label}>
          <div className={Styles.usageRowLeft}>
            <div className={Styles.usageIconContainer}>{row.icon}</div>
            {row.label}
          </div>
          <div
            className={cx(Styles.usageRowRight, {
              [Styles.bold]: !!row.value && !!row.limit && row.value >= row.limit,
            })}
          >
            {row.value}/{row.limit ? row.limit : '∞'}
          </div>
        </div>
      ))}
    </div>
  )
}
